module.exports = __webpack_public_path__ + "img/loading-animate.c4ab61df.gif";